<template>
  <div class="home">
    <header class="navbar-home">
      <div class="logo-container-home">
        <a>
          <div class="logo">
            <img src="../assets/hs_logo_white.svg" alt="HeadStart" />
          </div>
        </a>
      </div>
    </header>
    <div class="landing-page-container">
      <div class="section-info">
        <div class="desc">
          <h1>Welcome to HeadStart</h1>
          <p>A platform which makes the process of hiring easier</p>
        </div>
        <div class="illu">
          <img src="../assets/home_illustration_1.svg" alt="HeadStart" />
        </div>
      </div>
    </div>
    <footer>
      <span
        >For inquiries, drop an email to us at
        <a style="color: white" href="mailto:headstart-support@infocusp.com"
          >headstart-support@infocusp.com</a
        ></span
      >
      <span
        ><strong>Contact Address:</strong> 4th Floor, Gala Hub ANX, beside
        Basant Bahar, South Bopal, Bopal, Ahmedabad, Gujarat 380058</span
      >
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      tabs: ['Home', 'fill-details', 'read-instructions'],
    }
  },
}
</script>

<style>
.home {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #329bf5;
}
.navbar-home {
  display: flex;
  flex-direction: row;
  height: 64px;
  color: white;
  position: fixed;
  width: 100%;
}
.logo-container-home {
  margin-left: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.landing-page-container {
  padding-top: 80px;
  color: white;
}
.section-info {
  display: flex;
  padding: 32px;
}
.section-info .desc {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 140px;
  width: 50%;
}
.section-info .desc h1 {
  margin-bottom: 16px;
}
.section-info .illu {
  width: 50%;
  display: flex;
  justify-content: center;
}
.illu img {
  width: 90%;
  height: 90%;
}
footer {
  color: white;
  padding: 16px;
  margin-left: 130px;
}
footer span {
  display: block;
}
</style>
